<template>
<span id="generate-shipments-manually">
  <el-button
    id="btn-generate-shipments-manually"
    type="success"
    plain @click="dialogVisible = true"
    size="mini"
    class="margin-r-10"
  >
    {{ $t('customerService.billOfLading.generateShipments') }}
  </el-button>

  <el-dialog
    :close-on-click-modal="false"
    v-on:open="handleOpen"
    :title="$t('customerService.billOfLading.generateShipments')"
    :visible.sync="dialogVisible"
    width="30%"
    class="dialog-with-cols"
    append-to-body
    :before-close="handleClose"
  >
  <el-form :model="form" :rules="formRules" ref="form" label-position="top" size="mini">
      <el-row>
          <el-col :span="24">
              <el-form-item :label="$t('customerService.billOfLading.revenue')" prop="revenue">
                  <el-select v-model="form.revenue">
                  <el-option
                    v-for="item in revenueOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
          </el-col>
          <el-col :span="24">
              <el-form-item :label="$t('customerService.billOfLading.outboundWarehouse')" prop="outboundWarehouseId">
                  <outbound-warehouse-select v-model="form.outboundWarehouseId" :includeOptionAll="false"/>
              </el-form-item>
          </el-col>
      </el-row>
  </el-form>
  <div id="add-dialog-footer" slot="footer" class="dialog-footer form-vertical-item flex-reverse-direction">
      <el-button type="primary" id="form-save-button" @click="submitForm()"
                 size="mini">{{ $t('customerService.billOfLading.generateShipments') }}</el-button>
      <el-button id="form-refresh-button" @click="resetForm()" size="mini">
        {{ $t('common.clear') }}
      </el-button>
  </div>
  </el-dialog>
</span>
</template>

<script>
import constants from '@/utils/constants';
import OutboundWarehouseSelect from '@/views/routing/components/OutboundWarehouseSelect';

export default {
  components: { OutboundWarehouseSelect },
  props: {
    billOfLadingId: {
      type: Number,
      default: 0
    },
  },
  computed: {
    revenueOptions() {
      return [
        {
          value: constants.STATUS_BOOLEAN.yes.value,
          label: constants.STATUS_BOOLEAN.yes.label
        },
        {
          value: constants.STATUS_BOOLEAN.no.value,
          label: constants.STATUS_BOOLEAN.no.label
        }
      ];
    },
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        revenue: constants.STATUS_BOOLEAN.yes.value,
        outboundWarehouseId: null
      },
      formRules: {
        outboundWarehouseId: [
          {
            required: true,
            message: this.$t('customerService.billOfLading.error.outboundWarehouseRequired'),
            trigger: 'blur'
          },
        ]
      }
    };
  },
  methods: {
    handleOpen() {
      this.$nextTick(() => {
        this.resetForm();
      });
    },
    handleClose(done) {
      this.$store.dispatch('billOfLading/search', {});
      this.dialogVisible = false;
      done();
    },
    resetForm() {
      this.$refs.form.resetFields();
    },
    submitForm() {
      const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
      this.$store.dispatch('billOfLading/generateShipments', { billOfLadingId: this.billOfLadingId, ...this.form })
        .then((response) => {
          this.$message.success(response.message);
        })
        .finally(() => loading.close());
    }
  }
};
</script>
